<div class="main-content">
    <div class="container-fluid">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header card-header-danger">
                    <h4 class="card-title">Add Files</h4>
                </div>
                <div class="card-body">
                    <form #form="ngForm" (ngSubmit)="upload(form)">
                        <!-- Form fields -->
                        <div class="row">
                          <div class="col-md-6">
                            <label>Module Name <span class="red">*</span></label>
                            <ng-select class="form-control" [items]="modules" #ModuleName="ngModel" [multiple]="false"
                                       bindLabel="name" bindValue="id" required
                                        [(ngModel)]="form.moduleid" name="moduleid" [ngModelOptions]="{standalone: true}">
                            </ng-select>
                            <mat-error *ngIf="ModuleName.invalid && (ModuleName.dirty || ModuleName.touched)">
                              Module Name is required
                            </mat-error>
                          </div>
                      
                          <div class="col-md-6">
                            <div class="file btn btn-lg primary mt-4">
                              <input type="file" [(ngModel)]="form.file" (change)="onFileSelected($event)" #File="ngModel" required [ngModelOptions]="{standalone: true}" />
                            </div>
                            <mat-error *ngIf="File.invalid && (File.dirty || File.touched)">
                              File is required
                            </mat-error>
                          </div>
                        </div>
                      
                        <div class="row">
                          <div class="col-md-12 mt-4">
                            <mat-form-field class="example-full-width">
                              <input matInput placeholder="Description File" required #Description="ngModel" [(ngModel)]="form.descfile"
                                     [ngModelOptions]="{standalone: true}">
                              <mat-error *ngIf="Description.invalid && (Description.dirty || Description.touched)">
                                Description File is required
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      
                        <!-- Submit button -->
                        <button mat-raised-button type="submit" class="btn primary pull-right"
                                [disabled]="form.invalid || !form.moduleid || !form.file || !form.descfile">
                          Add Document
                        </button>
                      </form>
                      
                    <div class="row mt-4">
                        <div class="col-md-12">
                            <mat-form-field>
                                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                            </mat-form-field>
                        </div>
                     
                    </div>
               

                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                        <!-- Position Column -->
                        <ng-container matColumnDef="ModuleName">
                            <th mat-header-cell *matHeaderCellDef> Module Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.moduleName}} </td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="File">
                            <th mat-header-cell *matHeaderCellDef>File</th>
                            <td mat-cell *matCellDef="let element"> 
                                <button mat-icon-button class="btn primary" (click)="Download(element.file,element.moduleName)">
                                    <mat-icon>download</mat-icon>
                                  </button>                                </td>
                               
                        </ng-container>

                        
                                     <!-- Name Column -->
                                     <ng-container matColumnDef="Description">
                                        <th mat-header-cell *matHeaderCellDef>Description</th>
                                        <td mat-cell *matCellDef="let element"> {{element.desc}} </td>
                                    </ng-container>
            
                                    
                                    <ng-container matColumnDef="Status">
                                        <th mat-header-cell *matHeaderCellDef>Status</th>
                                        <td mat-cell *matCellDef="let element"> 
                                            <span *ngIf="element.private=='true'">Private</span>
                                            <span *ngIf="element.private=='false'">Public</span>
                                           </td>
                                    </ng-container>
                                    <ng-container matColumnDef="ClientName">
                                        <th mat-header-cell *matHeaderCellDef>Client Name</th>
                                        <td mat-cell *matCellDef="let element"> 
                                          {{element.ClientName}}
                                           </td>
                                    </ng-container>
                                    
                        <ng-container matColumnDef="Action">
                            <th mat-header-cell *matHeaderCellDef> Action </th>
                            <td mat-cell *matCellDef="let element">

                                <button mat-raised-button (click)="Delete(element.id)"><i class="material-icons">
                                        delete
                                    </i></button>

                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>